module.exports = __webpack_public_path__ + "media/images/icons/ic-avatar-male-47b9896fd495c35f0746dff0d77ca108.svg";